import { render } from "./ArrivalDeclarationCard.vue?vue&type=template&id=709a1cbc"
import script from "./ArrivalDeclarationCard.vue?vue&type=script&lang=js"
export * from "./ArrivalDeclarationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__